import { Injectable } from '@angular/core';
import { UserResponseModel } from '@auth-models/Response/UserResponseModel';
import { environment } from 'environments/environment';


@Injectable()
export class AppConfig {

  public static backOfficeUrl = environment.BackOfficeUrl;
  public static ticariUrl = environment.TicariUrl;
  public static smmUrl = environment.SmmUrl;
  public static mmUrl = environment.EmmUrl;
  public static ticketUrl = environment.TicketUrl;
  public static billUrl = environment.BillUrl;
  public static expenseVoucherUrl = environment.ExpenseVoucherUrl;

  public static debug = false;

  private static _webCode = [
    { code: 'TCR', name: 'Ticari Web Portal' },
    { code: 'STK', name: 'Stok Web Portal' },
    { code: 'BKO', name: 'Yönetim Web Portal' },
    { code: 'JobService', name: 'Servis' }
  ];

  public static userModel: UserResponseModel;

  public static setUser() {
    this.userModel = JSON.parse(localStorage.getItem('DashboardUser')) as UserResponseModel;
  }

  public static get webCode() {
    return AppConfig._webCode;
  }
  public static set webCode(value) {
    AppConfig._webCode = value;
  }
}
